export function combineMethodConfigs() {
  for (var _len = arguments.length, methodConfigs = new Array(_len), _key = 0; _key < _len; _key++) {
    methodConfigs[_key] = arguments[_key];
  }
  return methodConfigs.reduce((acc, config) => ({
    ...acc,
    [config.name]: config
  }), {});
}
export function combineApiConfigs() {
  for (var _len2 = arguments.length, configs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    configs[_key2] = arguments[_key2];
  }
  return configs.reduce((acc, config) => {
    const namesAcc = Object.keys(acc);
    const mutualMethods = Object.keys(config).filter(name => namesAcc.includes(name));
    if (mutualMethods.length) {
      console.debug("%cCombining Api Configurations conflicts in methods: " + mutualMethods + ", please rename these methods in your configurations to not conflict", 'color: red; font-size: larger');
    }
    return {
      ...acc,
      ...config
    };
  }, {});
}
//# sourceMappingURL=combineApiConfigs.js.map